import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { SiteUrl } from '@app/constants';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { Amplify } from 'aws-amplify';
import aws_exports from './aws-exports';

import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');
moment.updateLocale('es', { week: { dow: 0 } });

Amplify.configure(aws_exports);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

datadogRum.init({
  applicationId: environment.applicationId,
  clientToken: environment.clientToken,
  site: environment.site as SiteUrl,
  service: environment.service,
  env: environment.env,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: environment.defaultPrivacyLevel as DefaultPrivacyLevel,
});
